import {Component, ContentChild, Input, TemplateRef} from "@angular/core";
import {UtilsService} from "../../../../services/utils.service";

@Component({
  selector: "admin-accordion-nice",
  templateUrl: "./nice.component.html",
  styleUrls: ["./nice.component.css"]
})
export class NiceComponent<T = any> {
  @Input() items: T[] = [];

  @ContentChild("header", { static: true }) headerTemplate!: TemplateRef<any>;
  @ContentChild("first", { static: true }) firstTemplate!: TemplateRef<any>;
  @ContentChild("second", { static: true }) secondTemplate!: TemplateRef<any>;

  @Input() rowClick?: (item: T, index: number) => void;

  refid: string;

  constructor() {
    this.refid = UtilsService.generateRandomString();
  }

}
